import { navigateTo as navigateToHelper } from "../helpers/navigation_helpers"

export const navigateTo = function() {
  const url = this.getAttribute("url")
  const frame = this.getAttribute("frame") || "_top"
  const turbo = !(this.getAttribute("turbo") === "false")
  const turboAction = this.getAttribute("turbo_action") || "advance"
  const clearCache = this.getAttribute("clear_cache") === "true"

  // Clear cache before visit if needed (like turbo controller does)
  if (clearCache) {
    Turbo.cache.clear()
  }

  const options = { frame, action: turboAction, turbo }
  navigateToHelper(url, options)
}
